import { render, staticRenderFns } from "./good-Img-tag.vue?vue&type=template&id=5ec6eeb0&scoped=true"
import script from "./good-Img-tag.vue?vue&type=script&lang=js"
export * from "./good-Img-tag.vue?vue&type=script&lang=js"
import style0 from "./good-Img-tag.vue?vue&type=style&index=0&id=5ec6eeb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec6eeb0",
  null
  
)

export default component.exports